/* eslint-disable react/jsx-props-no-spreading */

import classNames from 'classnames';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Input, Label } from 'reactstrap';

const Radio = ({ name, value, label, disabled, required, formInput, defaultChecked, ...rest }) => {
  const inputRef = React.createRef();

  useEffect(() => {
    if (defaultChecked) {
      inputRef.current.checked = true;
    }
  }, [inputRef.current, defaultChecked]);
  return (
    <div className={classNames('input-radio radio m-0', { disabled })}>
      <Label className="m-0">
        {formInput ? (
          <Field
            name={name}
            ref={inputRef}
            type="radio"
            value={value}
            disabled={disabled}
            {...rest}
          />
        ) : (
          <Input type="radio" innerRef={inputRef} name={name} disabled={disabled} {...rest} />
        )}
        <span />
        {label} <span>{required ? '*' : ''}</span>
      </Label>
    </div>
  );
};

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  formInput: PropTypes.bool,
  defaultChecked: PropTypes.bool,
};

Radio.defaultProps = {
  disabled: false,
  required: false,
  formInput: true,
  defaultChecked: false,
};

export default Radio;
